import { init, Trans } from '@probatix/common/translations'

import { DEFAULT_LOCALE } from '@probatix/myprobatix/config/app'

import myprobatixTranslations from
  '@probatix/myprobatix/translations/frontend-myprobatix-translations.json'

const { de, en, fr } = myprobatixTranslations as any

const i18n = init({ de, en, fr }, DEFAULT_LOCALE || 'de')

export { Trans, init }
export { de, en, fr }
export default i18n
export const LANGUAGES = { de, en, fr }
